import Link from '@feature/Link';
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material'
import { useAppSelector } from 'app/hooks'
import { selectBreadcrumbs } from 'app/selectors'
import React from 'react'
// import { useLocation } from 'react-router';

const Breadcrumbs = () => {
  const breadcrumbs = useAppSelector(selectBreadcrumbs)

  return (
    <MuiBreadcrumbs aria-label="breadcrumb">
      {breadcrumbs.map(([label, uri], i) =>
        uri ? (
          <Link key={i} color="inherit" to={uri}>
            {label}
          </Link>
        ) : (
          <Typography key={i} color="text.primary">
            {label}
          </Typography>
        )
      )}
    </MuiBreadcrumbs>
  )
}

export default Breadcrumbs
